export default __webpack_public_path__ + "static/media/2023_September_Brombeere.45db4972.webp";